module.exports = __webpack_public_path__ + "media/images/eu25-6e6fba85d9602268c185706d3b97c494.svg";